import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { RsIcon } from './icons'
import { digestDisplaySummary, normalizeDigestText } from '../utils/digestHelpers'

export default function DigestTicker({ className = '', linkToPage = false }) {
  const [items, setItems] = useState([])

  useEffect(() => {
    axios
      .get('/api/digest/feed?limit=12')
      .then((res) => setItems(res.data))
      .catch(() => setItems([]))
  }, [])

  if (!items.length) return null

  const seen = new Set()
  const unique = []
  for (const item of items) {
    const key = normalizeDigestText(digestDisplaySummary(item)).slice(0, 120)
    if (!key || seen.has(key)) continue
    seen.add(key)
    unique.push(item)
  }

  const text = unique.map((i) => digestDisplaySummary(i)).join('  •  ')

  return (
    <div className={`bg-navy text-white overflow-hidden ${className}`}>
      <div className="max-w-7xl mx-auto flex items-center gap-3 px-4 py-2 text-sm">
        <Link to="/digest" className="font-semibold text-gold-400 flex-shrink-0 hover:text-white">
          Industry Digest
        </Link>
        <div className="flex-1 overflow-hidden">
          <p className="animate-marquee whitespace-nowrap">{text}</p>
        </div>
        {linkToPage ? (
          <Link to="/digest" className="flex-shrink-0 text-primary-200 hover:text-white flex items-center gap-1">
            View all <RsIcon name="externalLink" size={12} className="w-3 h-3" />
          </Link>
        ) : (
          <a
            href={items[0]?.original_url || '#'}
            target="_blank"
            rel="noreferrer"
            className="flex-shrink-0 text-primary-200 hover:text-white flex items-center gap-1"
          >
            Source <RsIcon name="externalLink" size={12} className="w-3 h-3" />
          </a>
        )}
      </div>
    </div>
  )
}
